

import React, { useEffect, useState } from 'react';
import { Button, Table, Row,Col,DatePicker, Pagination, Input, List, Skeleton, Modal, Select, Card, message } from 'antd';
import moment from 'moment';
import { requestError } from '../controllers/functions';
import axios from 'axios';
import { Link } from 'react-router-dom';
import BackOfficeExpenses from '../Back.Office.js/expenses/expsense';
import BackOfficeSchools from '../Back.Office.js/schools/schools';
import { LogoutOutlined, PlusOutlined, SendOutlined } from '@ant-design/icons';
import BillingMessagesPage from '../Back.Office.js/schools/billing.sms';

const { Option } = Select;

const SchoolsTable = () => {

  const [ loading , setLoading ] = useState(false);
  const [ schools , setSchools ] = useState([]);
  const [ expnses , setExpenses ] = useState([]);
  const [ date , setDate ] = useState(null);

  const [searchString, setSearchString] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);

  const [searchStringExpenses, setSearchStringExpenses] = useState(null);
  const [currentPageExpenses, setCurrentPageExpenses] = useState(1);

  const pageSize = 4; 

  const getSchools = React.useCallback(() => {
    setLoading(true);
    const f = {
            ...(date ? { date : date } : {}),
            ...(searchString ? { searchString } : {}),
            currentPage,
            pageSize
        }

    const q = new URLSearchParams(f).toString();
    axios.get(process.env.REACT_APP_API_URI+`/schools?${q}`, {headers: { authorization : `Bearer ${extractTokenFromUrl()}`}}).then(data =>{
      setSchools(data.data);
    }).catch(error =>{
      requestError({error})
    }).finally( done =>{
        setLoading(false)
    })
  }, [searchString, currentPage, pageSize, date ]);

  const getExpenses = React.useCallback(() => {
    setLoading(true);
    const f = {
            ...(date ? { date : date } : {}),
            ...(searchStringExpenses ? { searchString : searchStringExpenses } : {}),
            currentPage : currentPageExpenses,
            pageSize
        }

    const q = new URLSearchParams(f).toString();
    axios.get(process.env.REACT_APP_API_URI+`/back/office/expenses?${q}`, {headers: { authorization : `Bearer ${extractTokenFromUrl()}`}}).then(data =>{
      setExpenses(data.data);
    }).catch(error =>{
      requestError({error})
    }).finally( done =>{
        setLoading(false)
    })
  }, [searchStringExpenses, currentPageExpenses, pageSize, date ]);


  const deleteSchool = React.useCallback((id) => {
    axios.delete(process.env.REACT_APP_API_URI+`/schools/${id}`, {headers: { authorization : `Bearer ${extractTokenFromUrl()}`}}).then(data =>{
      getSchools(date);
    }).catch(error =>{
      requestError({error})
    })
  }, [date, getSchools]);

  const logout = () => {
    axios.get(process.env.REACT_APP_API_URI+`/auth/admin/logout`, {headers: { authorization : `Bearer ${extractTokenFromUrl()}`}}).then(data =>{
      window.location ='/'
    }).catch(error =>{
      requestError({error})
    })
  }

  const retryFailedSms = () => {
    axios.get(process.env.REACT_APP_API_URI+`/sms/retry`, {headers: { authorization : `Bearer ${extractTokenFromUrl()}`}}).then(data =>{
      message.success(data.data.res);
    }).catch(error =>{
      requestError({error})
    })
  }

  useEffect( () => {
    getSchools();
    getExpenses();
  }, [getSchools, getExpenses] );

  return (
    <div style={{ margin: "0rem"}}>


      <center style={{ marginTop : "1rem", marginBottom : "1rem" }}>

          <Select
            showSearch
            onChange={(v) => setDate(v)}
            placeholder="Select Month"
            optionFilterProp="children"
            style={{
              height : 29,
              marginBottom : "0.5rem", marginRight : "0.5rem"
            }}
        >
            {
              getMonthsBackwards().map(item =>
                <Option value={item} key={item}>
                    {moment(item, "MM-YYYY").format("MMM YYYY")}
                </Option>
              )
            }
        </Select>

        {/* <a target='blank' href={`http://139.84.239.205:9090/query?g0.expr=sum+by+%28instance%29+%28rate%28fundah_http_requests_total%5B1m%5D%29%29&g0.show_tree=0&g0.tab=graph&g0.range_input=2h&g0.res_type=fixed&g0.res_step=10&g0.display_mode=lines&g0.show_exemplars=0&g1.expr=sum+by+%28instance%29+%28rate%28fundah_http_requests_total%5B1m%5D%29%29%0A&g1.show_tree=0&g1.tab=graph&g1.range_input=1h&g1.res_type=fixed&g1.res_step=10&g1.display_mode=lines&g1.show_exemplars=0&g2.expr=sum%28rate%28fundah_http_requests_total%5B1m%5D%29%29%0A&g2.show_tree=0&g2.tab=graph&g2.range_input=1h&g2.res_type=fixed&g2.res_step=10&g2.display_mode=lines&g2.show_exemplars=0`}>
          <Button
            size="small"
            type="dashed"
            style={{  fontSize : 11.5, height : 29, marginBottom : "0.5rem", marginRight : "0.5rem" }}
          >
            Server Traffic 
          </Button>
        </a> */}

        <Link to={`/schools-newsletters?token=${extractTokenFromUrl()}`}>
          <Button
            size="small"
            type="dashed"
            style={{ 
              fontSize : 11.5, height : 29, marginBottom : "0.5rem", marginRight : "0.5rem"  
            }}
          >
            <SendOutlined /> Newsletter
          </Button>
        </Link>

        <Link to={`/new-school?token=${extractTokenFromUrl()}`}>
          <Button
            size="small"
            variant="dashed"
            color='green'
            style={{ fontSize : 11.5, height : 29, marginBottom : "0.5rem", marginRight : "0.5rem"  }}
          >
           <PlusOutlined /> School
          </Button>
        </Link>

        <Link to={`/new-organization?token=${extractTokenFromUrl()}`}>
          <Button
            size="small"
            variant="dashed"
            color='purple'
            style={{  fontSize : 11.5, height : 29, marginBottom : "0.5rem", marginRight : "0.5rem"  }}
          >
            <PlusOutlined /> Organization
          </Button>
        </Link>

        <a target='_blank' rel="noreferrer noopener" href={`https://drive.google.com/drive/folders/1Aq2G3uil0Qau_AOaBCUybVE1mwk1gmvn?usp=sharing`}>
          <Button
            size="small"
            variant="dashed"
            color='black'
            style={{  fontSize : 11.5, height : 29, marginBottom : "0.5rem", marginRight : "0.5rem"  }}
          >
            Download Desktop App
          </Button>
        </a>
        
        <Button
            size="small"
            variant = "dashed"
            color='blue'
            style={{  fontSize : 11.5, height : 29, marginBottom : "0.5rem", marginRight : "0.5rem"  }}
            onClick={retryFailedSms}
          >
           <LogoutOutlined /> Resend Failed Sms
        </Button>
        
        <Button
            size="small"
            variant = "dashed"
            color='red'
            style={{  fontSize : 11.5, height : 29, marginBottom : "0.5rem", marginRight : "0.5rem"  }}
            onClick={logout}
            danger
          >
           <LogoutOutlined /> Logout
        </Button>
      </center>
    
      <Row gutter={[5,5]} justify={'center'} style={{ marginTop : "1rem", marginBottom : "1rem", marginLeft:'0.5rem', marginRight:'0rem' }}>

        <Col xs={12} sm={8} md={8} lg={2}>
            <Card style={{ maxHeight : "100%", minHeight : "100%", textAlign : "center"}} className="payments-top-header-card">
                <div  className="payments-top-header-card-tittle"> Revenues</div>
                <div style={{ marginTop : 0 }}>
                    <span  style={{ color : "#3f8600", fontSize : 11.5 }} className="payments-top-header-card-content">{new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" }).format(schools.totalSubscription + schools.totalEconentSms*0.02 + schools.totalNetOneSms*0.03 )}</span>
                </div>
            </Card>
        </Col>

        <Col xs={12} sm={8} md={8} lg={3}>
            <Card  style={{ maxHeight : "100%", minHeight : "100%", textAlign : "center"}} className="payments-top-header-card">
                <div  className="payments-top-header-card-tittle"> Gross Profit</div>
                <div style={{ marginTop : 0 }}>
                    <span  style={{ color : "#3f8600", fontSize : 11.5 }} className="payments-top-header-card-content">{new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" }).format(schools.totalSubscription)}</span>
                    {" "}+{" "}
                    <span  style={{ color : "purple", fontSize : 11.5 }} className="payments-top-header-card-content">{" "} {new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" }).format( schools.totalEconentSms*0.011 + schools.totalNetOneSms*0.018 )}</span>
                    {" "}={" "}
                    <span  style={{ color : "#1677ff", fontSize : 11.5 }} className="payments-top-header-card-content">{" "} {new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" }).format( schools.totalSubscription + schools.totalEconentSms*0.011 + schools.totalNetOneSms*0.018 )}</span>

                </div>
            </Card>
        </Col>

        <Col xs={12} sm={8} md={8} lg={2}>
            <Card  style={{ maxHeight : "100%", minHeight : "100%", textAlign : "center"}} className="payments-top-header-card">
                <div  className="payments-top-header-card-tittle"> Expenses</div>
                <div style={{ marginTop : 0 }}>
                    <span  style={{ color : "#3f8600", fontSize : 11.5 }} className="payments-top-header-card-content">{new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" }).format(schools.totalUsdExpenses)}</span>
                </div>
            </Card>
        </Col>

        <Col xs={12} sm={8} md={8} lg={2}>
            <Card style={{ maxHeight : "100%", minHeight : "100%", textAlign : "center"}} className="payments-top-header-card">
                <div  className="payments-top-header-card-tittle"> Profit</div>
                <div style={{ marginTop : 0 }}>
                    <span  style={{ color : "#1677ff", fontSize : 11.5 }} className="payments-top-header-card-content">{" "} {new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" }).format( schools.totalSubscription + schools.totalEconentSms*0.02 + schools.totalNetOneSms*0.03 - schools.totalUsdExpenses )}</span>
                </div>
            </Card>
        </Col>

        <Col xs={12} sm={8} md={8} lg={3}>
            <Card style={{ maxHeight : "100%", minHeight : "100%", textAlign : "center"}} className="payments-top-header-card">
                <div  className="payments-top-header-card-tittle">(Cash + Bank) Receipts</div>
                <div style={{ marginTop : 0 }}>
                    <span  style={{ color : "#3f8600", fontSize : 11.5 }} className="payments-top-header-card-content">{new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" }).format(schools.totalUsdPaymentReceipt)}</span>
                </div>
            </Card>
        </Col>

        <Col xs={12} sm={8} md={8} lg={2}>
            <Card  style={{ maxHeight : "100%", minHeight : "100%", textAlign : "center"}} className="payments-top-header-card">
                <div  className="payments-top-header-card-tittle"> Cash Flow</div>
                <div style={{ marginTop : 0 }}>
                    <span  style={{ color : schools.totalUsdPaymentReceipt > schools.totalUsdExpenses ? "#1677ff" : "red", fontSize : 11.5 }} className="payments-top-header-card-content">{" "} {new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" }).format( schools.totalUsdPaymentReceipt - schools.totalUsdExpenses )}</span>
                </div>
            </Card>
        </Col>

        <Col xs={12} sm={8} md={8} lg={2}>
            <Card  style={{ maxHeight : "100%", minHeight : "100%", textAlign : "center"}} className="payments-top-header-card">
                <div  className="payments-top-header-card-tittle"> Econet Sms</div>
                <div style={{ marginTop : 0 }}>
                    <span  style={{ color : "#3f8600", fontSize : 11.5 }} className="payments-top-header-card-content">{new Intl.NumberFormat("en-US").format(schools.totalEconentSms)}</span>
                    <span  style={{ color : "#1677ff", fontSize : 11.5 }} className="payments-top-header-card-content">{" "} ({new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" }).format(schools.totalEconentSms*0.02)})</span>
                </div>
            </Card>
        </Col>

        <Col xs={12} sm={8} md={8} lg={2}>
            <Card  style={{ maxHeight : "100%", minHeight : "100%", textAlign : "center"}} className="payments-top-header-card">
                <div  className="payments-top-header-card-tittle"> NetOne Sms</div>
                <div style={{ marginTop : 0 }}>
                    <span  style={{ color : "#3f8600", fontSize : 11.5 }} className="payments-top-header-card-content">{new Intl.NumberFormat("en-US").format(schools.totalNetOneSms)}</span>
                    <span  style={{ color : "#1677ff", fontSize : 11.5 }} className="payments-top-header-card-content">{" "} ({new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" }).format(schools.totalNetOneSms*0.03)})</span>
                </div>
            </Card>
        </Col>

        <Col xs={12} sm={8} md={8} lg={3}>
            <Card style={{ maxHeight : "100%", minHeight : "100%", textAlign : "center"}} className="payments-top-header-card">
                <div  className="payments-top-header-card-tittle"> Econet Sms (Profit)</div>
                <div style={{ marginTop : 0 }}>
                    
                    <span  style={{ color : "#3f8600", fontSize : 11.5 }} className="payments-top-header-card-content">{" "} {new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" }).format(schools.totalEconentSms*0.0111)} Profit</span>
                    <span  style={{ color : "#1677ff", fontSize : 11.5 }} className="payments-top-header-card-content">{" "} ({new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" }).format(schools.totalEconentSms*0.0089)} Cost)</span>

                </div>
            </Card>
        </Col>

        <Col xs={12} sm={8} md={8} lg={3}>
            <Card style={{ maxHeight : "100%", minHeight : "100%", textAlign : "center"}} className="payments-top-header-card">
                <div  className="payments-top-header-card-tittle"> NetOne Sms (Profit)</div>
                <div style={{ marginTop : 0 }}>
                    <span  style={{ color : "#3f8600", fontSize : 11.5 }} className="payments-top-header-card-content">{new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" }).format(schools.totalNetOneSms*0.018)} Profit</span>
                    <span  style={{ color : "#1677ff", fontSize : 11.5 }} className="payments-top-header-card-content">{" "} ({new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" }).format(schools.totalNetOneSms*0.012)} Cost)</span>
                </div>
            </Card>
        </Col>


        <Col xs={12} sm={8} md={8} lg={3}>
            <Card  style={{ maxHeight : "100%", minHeight : "100%", textAlign : "center"}} className="payments-top-header-card">
                <div  className="payments-top-header-card-tittle"> Econet Sms</div>
                <div style={{ marginTop : 0 }}>
                    <span  style={{ color : "red", fontSize : 11.5 }} className="payments-top-header-card-content">{new Intl.NumberFormat("en-US").format(schools.totalFailedEconentSms)} Failed</span>
                </div>
            </Card>
        </Col>

        <Col xs={12} sm={8} md={8} lg={3}>
            <Card  style={{ maxHeight : "100%", minHeight : "100%", textAlign : "center"}} className="payments-top-header-card">
                <div  className="payments-top-header-card-tittle"> NetOne Sms</div>
                <div style={{ marginTop : 0 }}>
                    <span  style={{ color : "red", fontSize : 11.5 }} className="payments-top-header-card-content">{new Intl.NumberFormat("en-US").format(schools.totalFailedNetOneSms)} Failed</span>
                </div>
            </Card>
        </Col>


      </Row>


      <Row  gutter={[10, 10]} style={{ marginLeft:'0.5rem', marginRight:'0.5rem'}} >

        <Col  xs={24} sm={24} md={24} lg={8} xl={8} style={{ padding: "0.5rem", paddingBottom : 0 }} >
          <BackOfficeExpenses
          refresh={ () => {
            getSchools();
            getExpenses();
          }}
          deleteSchool={deleteSchool}
          expnses={expnses}
          loading={loading}
          currentPage={currentPageExpenses}
          setCurrentPage={setCurrentPageExpenses}
          setSearchString={setSearchStringExpenses}
          pageSize={pageSize}
          extractTokenFromUrl={extractTokenFromUrl}
          />
        </Col>

        <Col  xs={24} sm={24} md={24} lg={8} xl={8} style={{ padding: "0.5rem", paddingBottom : 0  }}>
          <BackOfficeSchools
          refresh={getSchools}
          deleteSchool={deleteSchool}
          schools={schools}
          loading={loading}
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
          pageSize={pageSize}
          extractTokenFromUrl={extractTokenFromUrl}
          setSearchString={setSearchString}
          getMonthsBackwards = {getMonthsBackwards}
          />
        </Col>

        <Col  xs={24} sm={24} md={24} lg={8} xl={8} style={{ padding: "0.5rem", paddingBottom : 0  }}>
          <BillingMessagesPage/>
        </Col>

      </Row>

    </div>
  );
};

function getMonthsBackwards() {
  const months = [];
  const current = moment();
  const end = moment().subtract(10, "years");

  while (current.isSameOrAfter(end, "month")) {
    months.push(current.format("MM-YYYY"));
    current.subtract(1, "month");
  }

  return months;
}

export default SchoolsTable;

const extractTokenFromUrl = () =>{
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    return urlParams.get('token');
}

export { extractTokenFromUrl, getMonthsBackwards };